/* VEROCONIC v14 - reliable product variant + add-to-cart fix */
(function () {
  'use strict';

  function esc(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~\\':"!^$\[\]()=>|\/@])/g, '\\$1');
  }

  function getPicker(target) {
    return target && target.closest
      ? target.closest('variant-radios-detail, variant-group-detail, variant-radios-single')
      : null;
  }

  function getVariants(picker) {
    if (!picker) return [];
    if (picker.__veroconicVariants) return picker.__veroconicVariants;
    try {
      var json = picker.querySelector('script[type="application/json"]');
      picker.__veroconicVariants = json ? JSON.parse(json.textContent) : [];
    } catch (e) {
      picker.__veroconicVariants = [];
    }
    return picker.__veroconicVariants;
  }

  function selectedValues(picker) {
    var values = [];
    picker.querySelectorAll('.product-form__input').forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      if (checked) values.push(checked.value);
      else if (select) values.push(select.value);
    });
    return values;
  }

  function selectedVariant(picker) {
    var values = selectedValues(picker);
    if (!values.length) return null;
    return getVariants(picker).find(function (variant) {
      return variant.options && variant.options.every(function (option, index) {
        return values[index] === option;
      });
    }) || null;
  }

  function updateVisibleOptionLabels(picker, variant) {
    if (!picker) return;
    var groups = picker.querySelectorAll('.product-form__input');
    groups.forEach(function (group, index) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      var value = checked ? checked.value : (select ? select.value : null);
      if (!value && variant && variant.options) value = variant.options[index];
      if (!value) return;

      group.querySelectorAll('.form__label .option_value, swatch-dropdown-select-value .option_value, .option_drop_value .option_value')
        .forEach(function (preview) {
          preview.textContent = value;
        });
    });
  }

  function syncVariantId(picker, variant) {
    if (!picker || !variant) return;
    var section = picker.dataset.section;
    if (!section) return;

    var selector = '#product-form-' + esc(section) + ', #sticky-addcart-form-' + esc(section);
    document.querySelectorAll(selector).forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      idInput.disabled = false;
      idInput.value = variant.id;
    });
  }

  function forceVariantUI(picker) {
    if (!picker) return;
    var variant = selectedVariant(picker);
    updateVisibleOptionLabels(picker, variant);
    if (variant) syncVariantId(picker, variant);
  }

  // Capture the real selected option before/after the theme's own variant code.
  document.addEventListener('change', function (event) {
    var picker = getPicker(event.target);
    if (!picker) return;

    forceVariantUI(picker);
    // The theme updates parts of the product UI later in the same event.
    // Re-apply from the checked inputs after it finishes so "Size: XL" cannot revert to S.
    setTimeout(function () { forceVariantUI(picker); }, 0);
    setTimeout(function () { forceVariantUI(picker); }, 80);
  }, true);

  // Also handle label taps immediately on mobile browsers.
  document.addEventListener('click', function (event) {
    var label = event.target.closest && event.target.closest('label[for]');
    if (!label) return;
    var picker = getPicker(label);
    if (!picker) return;
    setTimeout(function () { forceVariantUI(picker); }, 0);
  }, true);

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('loading', loading);
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('disabled');
    }
  }

  function showFormError(productForm, message) {
    if (!productForm || !message) return;
    var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    var text = productForm.querySelector('.product-form__error-message');
    if (text) text.textContent = message;
    if (wrapper) wrapper.hidden = false;
  }

  function refreshCartCount() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (res) { return res.json(); }).then(function (cart) {
      if (typeof cart.item_count === 'undefined') return cart;
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count;
      });
      return cart;
    }).catch(function () { return null; });
  }

  function updateMiniCart(cartElement, response) {
    if (!cartElement || !response || !response.sections || typeof cartElement.getSectionsToRender !== 'function') return false;
    try {
      cartElement.getSectionsToRender().forEach(function (section) {
        var htmlText = response.sections[section.id];
        if (!htmlText) return;
        var destination = document.getElementById(section.id);
        if (!destination) return;
        var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
        var source = parsed.querySelector('#minicart-form') || parsed.querySelector('#' + esc(section.id));
        if (source && destination.id === 'minicart-form') destination.innerHTML = source.innerHTML;
        else if (source) destination.innerHTML = source.innerHTML;
      });
      if (typeof cartElement.cartAction === 'function') cartElement.cartAction();
      if (cartElement.classList.contains('is-empty')) cartElement.classList.remove('is-empty');
      if (typeof cartElement.open === 'function') cartElement.open();
      return true;
    } catch (e) {
      console.error('VEROCONIC mini cart refresh error', e);
      return false;
    }
  }

  // Use a capture-phase submit handler so the old theme handler cannot leave the button spinning.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    var submitter = event.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') return;

    var productForm = form.closest('product-form');
    if (!productForm) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = submitter || productForm.querySelector('[name="add"]');
    setButtonLoading(button, true);

    // One final sync from the checked size/color inputs before creating FormData.
    var productItem = form.closest('.product__item-js') || document;
    var picker = productItem.querySelector('variant-radios-detail, variant-group-detail, variant-radios-single');
    if (picker) forceVariantUI(picker);

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.disabled = false;
    if (!idInput || !idInput.value) {
      showFormError(productForm, 'Please select an available option.');
      setButtonLoading(button, false);
      return;
    }

    var cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData(form);

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      try {
        formData.append('sections', cartElement.getSectionsToRender().map(function (section) { return section.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cartElement.setActiveElement === 'function') cartElement.setActiveElement(document.activeElement);
      } catch (e) {
        console.warn('VEROCONIC cart sections unavailable', e);
      }
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            var message = data.description || data.message || 'Unable to add this product to cart.';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function (data) {
        refreshCartCount();
        var opened = updateMiniCart(cartElement, data);
        if (!opened && cartElement && typeof cartElement.open === 'function') {
          try { cartElement.open(); } catch (e) {}
        }
      })
      .catch(function (error) {
        console.error('VEROCONIC add to cart error', error);
        showFormError(productForm, error.message || 'Unable to add this product to cart.');
      })
      .finally(function () {
        setButtonLoading(button, false);
      });
  }, true);

  // Correct initial captions/variant IDs after page load and Shopify section reloads.
  function syncAll() {
    document.querySelectorAll('variant-radios-detail, variant-group-detail, variant-radios-single').forEach(forceVariantUI);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();

  document.addEventListener('shopify:section:load', function () { setTimeout(syncAll, 0); });
})();
